import {createSlice } from '@reduxjs/toolkit'

const PeriodSlice = createSlice({
    name: "PeriodSlice",
    initialState: {
        Period: {
            PeriodOn: false,
            MinDay: 0,
            MaxDay: 0,
        }
    },
    reducers: {
       setPeriod(state, actions){
            state.Period.MinDay = parseInt(actions.payload.MinDay) - 2
            state.Period.MaxDay = parseInt(actions.payload.MaxDay)
            state.Period.PeriodOn = actions.payload.PeriodOn
       },
       clearPeriod(state){
            state.Period.MinDay = 0
            state.Period.MaxDay = 0
            state.Period.PeriodOn = false
       }
    }
})

export default PeriodSlice.reducer
export const { setPeriod, clearPeriod} = PeriodSlice.actions